import React from 'react';

export default function useUploadControllers(setFiles, onClose, isOpen, files = []) {
    const uploadControllers = React.useRef([]);
    const initialServerFilesRef = React.useRef(null);
    const onCloseRef = React.useRef(onClose);

    React.useEffect(() => {
      if (initialServerFilesRef.current === null) {
        const seeded = Array.isArray(files) ? files.filter(f => f && f.fromServer === true) : [];
        if (seeded.length > 0) initialServerFilesRef.current = seeded;
      }
    }, [files]);

    React.useEffect(() => {
      onCloseRef.current = onClose;
    }, [onClose]);

    const handleClose = React.useCallback(() => {
      uploadControllers.current.forEach(ctrl => ctrl.abort && ctrl.abort());
      uploadControllers.current = [];

      if (setFiles) {
        setFiles(() => initialServerFilesRef.current || []);
      }

      onCloseRef.current && onCloseRef.current();
    }, []);

    React.useEffect(() => {
        return () => {
            uploadControllers.current.forEach(ctrl => ctrl.abort && ctrl.abort());
            uploadControllers.current = [];
        };
    }, []);
      React.useEffect(() => {
      if (isOpen) {
        uploadControllers.current = [];
      }
    }, [isOpen])

    return { uploadControllers, handleClose };
}